/**
 * 活动管理模块路由
 * 路径前缀: /desktopCenter/activityManage/
 */
import type { RouteRecordRaw } from "vue-router";

export const activityManageRoutes: RouteRecordRaw[] = [
	{
		path: "/desktopCenter/activityManage/activityList",
		name: "ActivityList",
		meta: {
			title: "活动列表",
			keepAlive: false,
			iframeUrl: "cos.php/wdsxh/activity/activity",
		},
		component: () => import("@main/views/Apps/ActivityManage/ActivityList/ActivityList.vue"),
	},
	{
		path: "/desktopCenter/activityManage/activityRegistration",
		name: "ActivityRegistration",
		meta: {
			title: "活动报名",
			keepAlive: false,
			iframeUrl: "cos.php/wdsxh/activity/activity_apply",
		},
		component: () =>
			import("@main/views/Apps/ActivityManage/ActivityRegistration/ActivityRegistration.vue"),
	},
	{
		path: "/desktopCenter/activityManage/activityRefund",
		name: "ActivityRefund",
		meta: {
			title: "活动退款",
			keepAlive: false,
			iframeUrl: "cos.php/wdsxh/activity/refund",
		},
		component: () => import("@main/views/Apps/ActivityManage/ActivityRefund/ActivityRefund.vue"),
	},
	{
		path: "/desktopCenter/activityManage/electronicCertificate",
		name: "ElectronicCertificate",
		meta: {
			title: "电子证书",
			keepAlive: false,
			iframeUrl: "cos.php/wdsxh/activity/activity_electronic_certificate/index",
		},
		component: () =>
			import("@main/views/Apps/ActivityManage/ElectronicCertificate/ElectronicCertificate.vue"),
	},
	{
		path: "/desktopCenter/activityManage/pointsRanking",
		name: "PointsRanking",
		meta: {
			title: "积分排行",
			keepAlive: false,
			iframeUrl: "cos.php/wdsxh/points/ranking",
		},
		component: () => import("@main/views/Apps/ActivityManage/PointsRanking/PointsRanking.vue"),
	},
];
